import * as go from 'gojs';

type Options = {
  weight?: number;
  scale?: number;
};

export const getFont = ({ weight = 500, scale = 1 }: Options) =>
  new go.Binding('font', '', (data, node) => {
    const canvasBodyFontSize = node.part.data.canvasBodyFontSize;
    const font = data?.font ?? 'Sandvik Sans Text';
    return `normal normal ${weight} ${
      canvasBodyFontSize.size * scale
    }px ${font}`;
  });
